<template>
  <ico-moon :icon-set="getIconSet" :name="name" v-bind="$props"></ico-moon>
</template>

<script>
import iconSet from '../selection';
import IconMixin from '../Mixins/IconMixin';
import IcoMoon from '../Components/IcoMoon';

export default {
  name: 'DEIcon',
  components: { IcoMoon },
  mixins: [IconMixin],
  computed: {
    getIconSet: function () {
      return iconSet;
    },
  },
};
</script>
